<script setup lang="ts">
import { useAssistantSettingsStore } from "@/stores/assistantSettingsStore";

const emit = defineEmits(["close"]);

const { assistantSettings } = useAssistantSettingsStore();

const { logout } = useSanctumAuth();

const close = () => {
  emit("close");
};

const closeAndLogout = () => {
  close();
  logout();
};

const openUrl = async (url: string, external: boolean = false) => {
  if (!external) {
    close();
  }
  await navigateTo(url, {
    external: external,
    open: external
      ? {
          target: "_blank",
        }
      : undefined,
  });
};
</script>

<template>
  <div class="menu">
    <BaseIcon name="close" class="close" @click="close" />
    <nav class="nav">
      <MainMenuItem @click="openUrl('/')"> Home </MainMenuItem>
      <MainMenuItem @click="openUrl('/support')"> Support </MainMenuItem>
      <div
        v-if="assistantSettings.menu.items.length > 0"
        class="nav-divider"
      ></div>
      <MainMenuItem
        v-for="(item, index) in assistantSettings.menu.items"
        :key="index"
        external
        small
        @click="openUrl(item.url, true)"
      >
        {{ item.label }}
      </MainMenuItem>
    </nav>
    <div
      v-if="!assistantSettings.config.has_auto_login"
      class="logout"
      @click="closeAndLogout"
    >
      <BaseIcon name="logout" class="icon" />
      Logout
    </div>
    <PoweredBy
      v-if="assistantSettings.config.has_branding"
      class="powered-by"
    />
  </div>
</template>

<style lang="scss" scoped>
.menu {
  position: fixed;
  display: flex;
  flex-direction: column;
  background: var(--menu-body-background-color);
  color: var(--menu-body-text-color);
  overflow: auto;
  inset: 0;
  padding: env(safe-area-inset-top) env(safe-area-inset-right)
    env(safe-area-inset-bottom) env(safe-area-inset-left);

  a {
    color: var(--menu-body-text-color);
  }
}

.nav {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  gap: 20px;
  padding: 20px 0;
}

.nav-divider {
  border-top: 1px solid var(--menu-body-text-color);
  margin: 10px 30px;
  opacity: 0.1;
}

.close {
  position: sticky;
  top: 20px;
  right: 20px;
  align-self: flex-end;
  margin: 20px 20px 0 20px;
  font-size: 2.5rem;
  cursor: pointer;
}

.logout {
  display: flex;
  font-weight: bold;
  cursor: pointer;
  margin: 0 auto;

  .icon {
    margin-right: 0.2em;
  }
}

.powered-by {
  margin: 30px;
  align-self: center;
}
</style>
